import { render, staticRenderFns } from "./CollapsableModal.vue?vue&type=template&id=656d7bfa&scoped=true&"
import script from "./CollapsableModal.vue?vue&type=script&lang=js&"
export * from "./CollapsableModal.vue?vue&type=script&lang=js&"
import style0 from "./CollapsableModal.vue?vue&type=style&index=0&id=656d7bfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656d7bfa",
  null
  
)

export default component.exports